import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const leanIxPickerFormFieldExtension: ExtensionDefinition =
  FormFieldBlueprint.make({
    name: 'leanix-picker-form-field-extension',
    params: {
      field: () => import('./leanix-picker').then(m => m.LeanIxPickerFormField),
    },
  });
